import script from "./SmSecondButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmSecondButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__